import { useDelete, UseDeleteParams } from '../../../../api';
import { useCallback } from 'react';
import { USER_MANAGEMENT_BASE_URL } from '../consts';
import { DeviceToken } from '../../types/User';

interface DeleteTokenResponse {
    tokenId: DeviceToken['id'];
}

interface DeleteTokenErrorResponse {
    error: string;
}

export type UseDeleteTokenParams = UseDeleteParams<DeleteTokenResponse, DeleteTokenErrorResponse>;

export const useDeleteToken = (params: UseDeleteTokenParams) => {
    const { deleteMethod, loading, error } = useDelete(params);

    const deleteToken = useCallback(
        (userId: DeviceToken['userId'], tokenId: DeviceToken['id']) =>
            deleteMethod(`${USER_MANAGEMENT_BASE_URL}/token/${tokenId}?userId=${userId}`),
        [deleteMethod]
    );

    return {
        loading,
        error,
        deleteToken
    };
};
